<template>
  <span class="rounded ml-2" style="font-size:0.8rem;padding:0px 10px 0px 10px;display:inline-block;color:white;background-color:#E4007F;">{{$t("共通.21")}}</span>
</template>